import type { DataChartStyleProps } from './datachartStyleRegistry'
import { TemperatureChartBase } from './TemperatureChartBase'

export function TemperatureChartStyle01(props: DataChartStyleProps) {
  return <TemperatureChartBase variant="blue" {...props} />
}
